module.exports = __webpack_public_path__ + "static/media/play-button.b3e34a4d.svg";